namespace JupitersChoice {
    export class OnFreeGameReadyCmd {

        @inject('ComponentManager') _componentManager: Sapphire.ComponentManager;
        @inject('EventManager') _eventManager: Sapphire.EventManager;
        @inject('StageLoadModel') _stageLoadModel: Sapphire.StageLoadModel;
        @inject('LayerManager') _layerManager: Sapphire.LayerManager;
        @inject('StateModel') _stateModel: Sapphire.StateModel;

        execute(): void {
            this._stageLoadModel.addLoadedStage("FreeGame");

            this._componentManager.get('JupiterFreeGameLandscape').pause();
            this._componentManager.get('JupiterFreeGamePortrait').pause();
            this._componentManager.get('FreeGameSky').pause();

            for (let i = 1; i < 9; i++) {
                this._componentManager.get(`FreeGameFlame${i}`).hide();
                this._componentManager.get(`FreeGameFlame${i}`).stop();
            }

            // has the player triggered free game but been kicked back to the preloader (free game assets pending)
            if (this._stateModel.currentSubgame === "BaseGame" && this._stateModel.currentState === "CheckSpinnerPrize") {
                this._eventManager.publish("onHidePreloader");
                this._eventManager.publish("onEnterState:CheckSpinnerPrize");
            }
        }
    }
}